import axios from "axios";
import API_BASE_URL from "../config/apiConfig";

const config = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("adminToken") || ""}` },
});

const url = (bookingId, category) =>
  `${API_BASE_URL}/api/admin/bookings/${bookingId}/misc-vendor-payments/${category}`;

export const getBookingMiscVendorPayments = async (bookingId, category) =>
  (await axios.get(url(bookingId, category), config())).data;

export const recordBookingMiscVendorPayment = async (bookingId, category, payment) =>
  (await axios.post(url(bookingId, category), payment, config())).data;

// Corrections need a reason; a delete keeps the payment on record but out of every total.
export const editBookingMiscVendorPayment = async (bookingId, category, paymentId, change) =>
  (await axios.put(`${url(bookingId, category)}/${paymentId}`, change, config())).data;

export const deleteBookingMiscVendorPayment = async (bookingId, category, paymentId, reason) =>
  (await axios.post(`${url(bookingId, category)}/${paymentId}/delete`, { reason }, config())).data;
